<template>
  <!-- Hauptcontainer mit definierter Höhe -->
  <div class="flex flex-col h-full w-full">
    <div class="flex-grow overflow-auto w-full bg-trader-gray">
      <!-- Liste -->
      <div class="flex flex-col gap-1 w-full">
        <div v-for="(data, index) in filteredDataList" :key="data.id" :ref="el => addRef(el, data.id)"
             class="w-full p-1 border-trader-dark-gray" :class="{ 'bg-trader-blue text-trader-highlight': data.id == selectItem }"
             @click="getSelectItem(data)">
          {{ data.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed, nextTick, ref, watch} from "vue";

// Props
const props = defineProps({
  dataList: Array,
  searchInput: {
    type: String,
    required: false,
    default: "",
  },
  style: Object,
  selectedId: Number,
  formatCellValue: {
    type: Function,
    required: false,
    default: (dataRow: any, field: string) => {
      return dataRow[field];
    },
  },
  onSelectionChange: {
    type: Function,
    required: false,
    default: (rows: any[]) => {
    },
  },
  onPageStep: {
    type: Function,
    required: false,
    default: (step: number) => {
    },
  },
});

// Refs und Daten
const selectItem = ref(props.selectedId || null);
const selectItemValue = ref(null);
const refs = ref(new Map()); // Map für Referenzen

// Funktion zum Hinzufügen von Referenzen
function addRef(el, id) {
  if (el) refs.value.set(id, el); // Element zur Map hinzufügen
  else refs.value.delete(id); // Element aus der Map entfernen, wenn nicht mehr vorhanden
}

// Daten filtern
const filteredDataList = computed(() => {
  if (!props.searchInput || props.searchInput.trim() === "") {
    return props.dataList;
  } else {
    return props.dataList.filter((item) =>
        item.value.toLowerCase().includes(props.searchInput.toLowerCase())
    );
  }
});

// Element auswählen
function getSelectItem(data) {
  selectItemValue.value = data;
  selectItem.value = data.id;
  props.onSelectionChange(data); // Callback aufrufen
  scrollToItem(data.id); // Scrollen zum Element
}

// Scroll-Funktion
function scrollToItem(id) {
  nextTick(() => {
    const listItem = refs.value.get(id); // Element über Map abrufen
    if (listItem) {
      listItem.scrollIntoView({behavior: "smooth", block: "center"});
    }
  });
}

// Watcher, um auf Änderungen von selectedId zu reagieren
watch(
    () => props.selectedId,
    (newValue) => {
      selectItem.value = newValue;
      scrollToItem(newValue); // Scrollen bei externer Änderung
    },
    {immediate: true}
);
</script>

